import useRefereeList from '@amf/shared/data/hooks/useRefereeList';
import { RefereeLicense } from '@amf/shared/data/Referee';
import RefereeListItem from '@amf/shared/components/referee/RefereeListItem';
import { useTranslate } from '@tolgee/react';
import Loader from '@amf/shared/components/utils/Loader';
import Empty from '@amf/shared/components/utils/Empty';

interface Props {
  license: RefereeLicense | null;
  prefixes: { referee: string };
}

function RefereeList({ license, prefixes }: Props) {
  const { t } = useTranslate();
  const { referees, loadMore, loading } = useRefereeList(license);

  if (loading) return <Loader>{t('referee.list.loading')}</Loader>;
  if (!loading && referees.length === 0) return <Empty>{t('referee.list.empty')}</Empty>;
  return (
    <div className='RefereeList'>
      <div className='RefereeList__list'>
        {referees.map(referee => (
          <RefereeListItem key={referee.id} referee={referee} link={prefixes.referee} />
        ))}
      </div>
      {loadMore()}
    </div>
  );
}

export default RefereeList;
